export const baseEnvironment = {
  production: false,
  version: '4.6.1',
  region: 'us-east-2',
  authenticationType: 'OPENID_CONNECT',
  no_turnover_controller_notes_before: new Date(2022, 7, 1),
};
